import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import Vue from "vue";
import VueApollo from "vue-apollo";

Vue.use(VueApollo);

const httpLink = new HttpLink({
  uri: `${process.env.VUE_APP_URI}/${process.env.VUE_APP_API}?apikey=${process.env.VUE_APP_APIKEY}`
});

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: httpLink
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

export default apolloProvider;
